import React, {useState, useEffect} from 'react';
import  AppBar  from '../components/appbar.js';
import  SideBar  from '../components/sidebar.js';
import { Grid, Box, Stack, Autocomplete, TextField, IconButton, MenuItem, FormControl, Select, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { getWindowDimensions } from '../util';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { CustomAvatar } from  '../components/general';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallIcon from '@mui/icons-material/Call';
import { getCreditList } from '../services/credit.js'
import CreditDetails from '../components/creditDetails.js'
import dayjs from 'dayjs'
import { useDispatch } from "react-redux";
import { removeUserAction } from '../actions/profile.js';
import { useNavigate } from "react-router-dom";

const classes = {
  root: {
    flexDirection: "column",
  },
  container : {
    display: "flex",
    flexDirection: "row",
    width: '100%',
  },
  subcontainer : {
    padding: 2,
    width: '100%'
  }
};

const searchUser = (key) => {
    return (credit) => {
        if (key) {
            if (credit?.tenant?.name) {
                return credit?.tenant?.name.toLowerCase().includes(key.toLowerCase()) || credit?.tenant?.contactNumber.includes(key)
            }
            return false
        }
        return true
    } 
}

const PhoneRow = ({isMobile, phone}) => {

    const openWhatsapp = (e) => {
        e.stopPropagation();
        const url = `https://wa.me/+91${phone}`;
        window.open(url, '_blank');
    }

    const openDialer = (e) => {
        e.stopPropagation();
        const url = `tel:${phone}`;
        window.open(url, '_blank');
    }

    if (isMobile) {
        return (<TableCell align={'center'}>
            <Stack direction="row">
                <IconButton sx={{mr: 1}} onClick={openWhatsapp}><WhatsAppIcon/></IconButton>
                <IconButton onClick={openDialer}><CallIcon/></IconButton>
            </Stack>
        </TableCell>)
    }
    return (<TableCell align={'center'}>{phone} </TableCell>)

}

const UserSearch = ({isMobile, users, searchKey, setSearchKey}) => {
  return (
    <Autocomplete
      disablePortal
      freeSolo
      id="combo-box-demo"
      value={searchKey}
      getOptionLabel={(option) => { if (typeof option === "string"){ return option } return option?.user?.name}} // Used for display
      filterOptions={(opts, { inputValue }) =>
        opts.filter((opt) => {
          const search = inputValue.toLowerCase();
          return (
            opt.user.name.toLowerCase().includes(search) ||
            opt.user.contactNumber.includes(search)
          );
        })
      }
      onChange={(e, v)=> {
        if (v !== null) { 
          if (typeof v === "string") {
            setSearchKey(v)
          } else {
            setSearchKey(v.user.name)
          }
        } else {
          setSearchKey("")
        }
      }}
      options={users}
      sx={{ width: isMobile? '45%' : 300 }}
      renderInput={(params) => <TextField {...params} label="Search User" />}
    />
  )
}

const UserSort = ({sort, setSort}) => {
    return (
        <Stack direction="row" alignItems="center">
            <Typography  sx={{display: 'block ruby', wordBreak: 'keep-all', mr:1, color:'rgb(103, 103, 103)'}}>Sort By </Typography>
            <FormControl variant="standard" fullWidth>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={sort}
                    label="Age"
                    onChange={(e)=>{setSort(e.target.value)}}
                    disableUnderline={true}
                >
                    <MenuItem value={"date"}>Date</MenuItem>
                    <MenuItem value={"due-date"}>Name</MenuItem>
                    <MenuItem value={"credit"}>Credit</MenuItem>
                </Select>
            </FormControl>
            <IconButton>
                <SwapVertIcon/>
            </IconButton>
        </Stack>
    )
}

const Topbar = ({isMobile, searchKey, setSearchKey, users, sort, setSort}) => {
    return (
        <Stack direction="row" justifyContent="space-between">
            <UserSearch isMobile={isMobile} searchKey={searchKey} setSearchKey={setSearchKey} users={users}/>
            <UserSort sort={sort} setSort={setSort}/>
        </Stack>
    )
}

const Credits = () =>{

    const [searchKey, setSearchKey] = useState('')
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [sort, setSort] = useState("date")
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [credits, setCredits] = useState([])
    const [openDetails, setOpenDetails] = useState(false);
    const [selectedTenant, setSelectedTenant] = useState()
    const isMobile = windowDimensions.width < 500 ? true : false

    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const headers = isMobile ? 
        [
            {label:'Name', minWidth:170},
            {label:'DueDate', minWidth:150},
            {label:'Amount', minWidth:150},
            {label:'Phone', minWidth:150},
        ]
        :
        [
            {label:'Name', minWidth:170},
            {label:'Date', minWidth:150},
            {label:'Amount', minWidth:150},
            {label:'Phone', minWidth:150},
        ]

    const getData = async() => {
        try {
            const _data = await getCreditList();
            setCredits(_data)
        } catch (e) {
            if (e.status === 401) {
                dispatch(removeUserAction())
                navigate('/');
            }
        }
        
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    useEffect(() => {
        getData()
    }, [])    

    return (
         <Grid container component="main" sx={classes.root}>
            <AppBar/>
            <Box sx={classes.container}>
                <SideBar/>
                <Box sx={classes.subcontainer}>
                    <Topbar
                        isMobile={isMobile}
                        searchKey={searchKey}
                        setSearchKey={setSearchKey}
                        users={[]}
                        sort={sort}
                        setSort={setSort}
                    />
                    <TableContainer sx={classes.container}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {headers.map((column) => (
                                        <TableCell
                                            key={column.label}
                                            align={'center'}
                                            style={{ width: column.minWidth, fontWeight:600 }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {credits.filter(searchUser(searchKey)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, ind) => {
                                    return (
                                        <TableRow hover onClick={()=>{setSelectedTenant({tenant: row.tenant, total: row.amount}); setOpenDetails(true)}} tabIndex={-1} key={row._id}>
                                            <TableCell align={'center'}>
                                                <Stack direction="row" alignItems="center">
                                                    <CustomAvatar  src={row?.tenant?.image?.thumb??''} name={row?.tenant?.name}/>
                                                    <Typography>{row?.tenant?.name}</Typography>
                                                 </Stack>
                                                 </TableCell>
                                                <TableCell align={'center'}>{dayjs(row.lastUpdated).format('DD/MM/YYYY')} </TableCell>
                                                <TableCell align={'center'}>{row.amount}</TableCell>
                                                <PhoneRow isMobile={isMobile} phone={row?.tenant?.contactNumber}/>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        classes={classes.pagination}
                        count={credits.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Box>
            </Box>
            <CreditDetails
                selectedTenant={selectedTenant}
                open={openDetails}
                setOpen={setOpenDetails}
                isMobile={isMobile}
            />
        </Grid>

    )
}


export default Credits